.ch{outline:none;}